module.exports = __webpack_public_path__ + "static/media/b-flecha-CM.08c2ea51.webp";